import React from "react";
import { Grid, MenuItem, Select, Typography } from "@material-ui/core";
import { Label } from "../../../../../../components/formInputs";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import BirthDate from "./BirthDate";
import LicenceExpiry from "./LicenceExpiry";
import { forNonUsCitizen } from "../../../../../../constants";
import { isNfIulCase } from "../../../../../../utils/commonFunc";

const Citizenship = (props: any) => {
	const {
		fieldObj,
		fieldObj4,
		fieldObj7,
		minAge,
		proofExpireRef,
		proofExpired,
		clientSigned,
		conditionalRequired,
        setProofExpired,
		role,
		client,
		CommonField,
		values,
		errors,
		touched,
		setFieldValue,
		handleChange,
		handleBlur,
		setAnticipatedAge,
        setNonUSPopUp,
        accountActions,
        isFromClientDetail,
		fieldObj14
	} = props;
	const clientPolicy = client && client.clientPolicies.length > 0 && client.clientPolicies[0];
	return (
		<>
			<Grid item xs={12}>
				<span className="hLine" />
				<Typography variant="h6" className="fontBold w100 mb20">Citizenship Details</Typography>
			</Grid>
			<Grid container xs={12} alignContent="center" spacing={2} justify="space-between">
				<Grid item xs={4}>
					<Typography variant="caption" className="floatLeft">
						<Label label={"Are you a U.S. citizen?"}
							required={conditionalRequired} />
					</Typography>
					<ToggleButtonGroup id={"usCitizen"} className="toggleButtonGroup mb30" size="large" exclusive
									value={values["usCitizen"]}
									onChange={ async () => {
										setFieldValue("usCitizen", !values["usCitizen"]);
										setFieldValue("employeeSSN", "");
										setFieldValue("howLongInUS", "");
										setFieldValue("countryCitizenship", "");
										setFieldValue("immigrationStatus", "");
										setFieldValue("greenCardNo", "");
										setFieldValue("typeOfVisaPlanHeld", "");
										setFieldValue("typeOfVisaHeld", "");
										setFieldValue("immigrationStatusOther", "");
										setFieldValue("otherCitizenship", "");
										if (values["usCitizen"]) {
											setNonUSPopUp(true);
										}
										let payload: any = {};
										payload["usCitizen"] = !values["usCitizen"];
										await accountActions.updateUserBasicDetails(payload, (clientPolicy && clientPolicy.id) || 0, "");
									}}>
						<ToggleButton value={true} disabled={!!clientSigned}
									className={values["usCitizen"] ? "active" : ""}>
							Yes
						</ToggleButton>
						<ToggleButton value={false} disabled={!!clientSigned}
									className={values["usCitizen"] ? "" : "active"}>
							No
						</ToggleButton>
					</ToggleButtonGroup>
				</Grid>
                <Grid item xs={12} md={6} xl={4}>
                    <Typography variant="caption" className="floatLeft">
                        <Label label={"How would you like to verify your identity?"}
                               required={conditionalRequired} />
                    </Typography>
                    <ToggleButtonGroup
                            color={"primary"}
                            className="toggleButtonGroup"
                            size="large"
                            exclusive
                            id={"identityType"}
                            value={values["identityType"]}
                            onChange={(e: any, val: string) => {
                                setFieldValue("identityType", val);
                                setFieldValue("identityId", "");
                                setFieldValue("proofExpiryYear", 0);
                                setFieldValue("proofExpiryMonth", 0);
                                setProofExpired && setProofExpired(false);
                            }}
                    >
                        <ToggleButton value={"drivingLicence"}
                                      disabled={!!clientSigned}
                                      className={values["identityType"] === "drivingLicence" ? "active" : ""}>
                            Drivers License
                        </ToggleButton>
                        <ToggleButton value={"passport"}
                                      disabled={!!clientSigned}
                                      className={values["identityType"] === "drivingLicence" ? "" : "active"}>
                            Passport
                        </ToggleButton>
                    </ToggleButtonGroup>
                    {
                            values["identityType"] === "passport" && !isFromClientDetail &&
                            <span className="f12 colorRed floatLeft w100 mt15">
                                    Using a passport for ID will require utility docs for address verification.
                            </span>
                    }
                </Grid>

                <Grid item xs={8}>
						<Typography variant="caption">
							<Label label={"Do you have a dual citizenship?"}
								required={conditionalRequired} />
						</Typography>	
						<Grid item alignItems="center" justify="space-between" className="mt10" xs={12} container spacing={2}>
							<ToggleButtonGroup 
								id={"dualCitizen"} 
								className="" 
								size="large" exclusive
								value={values["dualCitizen"]}
								onChange={
										async() => {
											setFieldValue("dualCitizen", !values["dualCitizen"]);
											let payload: any = {};
											payload["dualCitizen"] = !values["dualCitizen"];
											await accountActions.updateUserBasicDetails(payload, (clientPolicy && clientPolicy.id) || 0, "");
											}
										}
							>
								<ToggleButton
									value={true}
									className={values["dualCitizen"] ? "active" : ""}
									disabled={!!clientSigned}
								>
									Yes
								</ToggleButton>
								<ToggleButton
									value={false}
									className={values["dualCitizen"] ? "" : "active"}
									disabled={!!clientSigned}
								>
									No
								</ToggleButton>
							</ToggleButtonGroup>
						{
							values["dualCitizen"] && fieldObj14.map((field, index) => {
													return (
														<Grid item xs={8} key={index + field["name"]}>
															<div>
																{
																	CommonField(
																		field,
																		{
																			values,
																			errors,
																			touched,
																			handleChange,
																			handleBlur,
																			setFieldValue,
																		},
																	)
																}
															</div>
														</Grid>
													)
							})
						}
						</Grid>						
					</Grid>
				
			</Grid>
            {fieldObj.map((field, index) => {
                if (field["show"]) {
                    if (role === 1 || role === 2 || role === 4) {
                        if (field["name"] === "blotSSN" && !client.blotSSN) {
                            return null;
                        } else {
                            if (field["name"] === "employeeSSN" && !(client && client.employeeSSN) && (client && client.blotSSN)) {
                                return null;
                            }
                        }
                    } else {
                        if (!values["usCitizen"] && field["name"] === "blotSSN") {
                            return null;
                        }
                        if (field["name"] === "blotSSN" && !clientSigned) {
                            return null;
                        }
                        if (values["usCitizen"] && field["name"] === "employeeSSN" && clientSigned) {
                            return null;
                        }
                    }

                    return (
                            <React.Fragment key={index}>

                                {field.name === "employeeSSN" &&
                                        <Grid item xs={12} md={4}>
                                            <Select
                                                    value={Number(values["nonUsCitizen"])}
                                                    name="nonUsCitizen"
                                                    variant="outlined"
                                                    onChange={e => {
                                                        setFieldValue("nonUsCitizen", Number(e.target.value));
                                                    }}
                                                    fullWidth
                                            >
                                                {
                                                    forNonUsCitizen.map((o) =>
                                                            <MenuItem key={o.value} value={o.value}>
                                                                {o.text}
                                                            </MenuItem>)
                                                }
                                            </Select>
                                        </Grid>
                                }

                                {field.name === "birthCountry" &&
                                        <BirthDate
                                                fieldObj4={fieldObj4}
                                                minAge={minAge}
                                                CommonField={CommonField}
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                setFieldValue={setFieldValue}
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                setAnticipatedAge={setAnticipatedAge}
                                                clientSigned={!!clientSigned}
                                        />
                                }

                                <Grid item xs={12}
                                      md={6}
                                      xl={3}
                                      key={index + field["name"]}>
                                    <>
                                        {
                                            CommonField(
                                                    field,
                                                    {
                                                        values,
                                                        errors,
                                                        touched,
                                                        handleChange,
                                                        handleBlur,
                                                        setFieldValue,
                                                    },
                                            )
                                        }
                                    </>
                                </Grid>


                                {field.name === "identityId" && <>
                                    <Grid item xs={12} ref={proofExpireRef} id="proofExpireRef">
                                        <Typography variant="caption" className="floatRight-">
                                            Expiry Date (must match {values["identityType"] === "drivingLicence" ? "drivers license" : "passport"})
                                        </Typography>
                                    </Grid>
                                    <Grid container spacing={2} style={{ marginLeft: 2, marginBottom: 20 }}>
                                        <LicenceExpiry
                                                fieldObj7={fieldObj7}
                                                proofExpireRef={proofExpireRef}
                                                proofExpired={proofExpired}
                                                CommonField={CommonField}
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                setFieldValue={setFieldValue}
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                        />
                                    </Grid>
                                </>}
                            </React.Fragment>
                    );
                }
            })
            }
		</>);
};
export default Citizenship;